import React, {useEffect, useState} from "react";
import {Box, Container} from "@mui/material";
import styled from "styled-components";
import logo from "assets/images/logos/fifa_plus_logo.svg";
import {MenuIcons} from "./MenuIcons";
import {MenuLinks} from "./MenuLinks";
import {DropdownMenu} from "./DropdownMenu";
import {HamburgerMenu} from "./HamburgerMenu";
import {DesktopSubNavigation} from "./DesktopSubNavigation";
import {useSelector} from "react-redux";
import {isMenuOpen} from "modules/selectors";
import {debounce} from "lodash";
import {useMediaQuery} from "modules";
import {Exist} from "components/Exist";
import {media} from "assets/css/media";

const Wrapper = styled.header`
	// header + subnavigation
	height: calc(56px + 64px);
	display: flex;

	align-items: center;
	flex-direction: column;
	background-color: ${({theme}) => theme.global.header_background};
	position: sticky;
	top: 0;
	z-index: 9999;

	@media screen and (max-width: ${media.mobile}) {
		height: 56px;
	}
`;

const InnerWrapper = styled.div`
	height: 56px;
	padding-top: 6px;
	padding-bottom: 6px;
`;

const DesktopMenuWrapper = styled.div`
	display: flex;
	justify-content: space-between;
	@media (max-width: ${media.large_desktop}) {
		display: none;
	}
`;

const MobileMenuWrapper = styled.div`
	display: none;
	align-items: center;
	@media (max-width: ${media.large_desktop}) {
		display: flex;
	}
`;

const DesktopMenu: React.FC = () => (
	<DesktopMenuWrapper>
		<Box
			sx={{
				display: "flex",
				alignItems: "center",
			}}>
			<DropdownMenu />
			<img src={logo} alt="Fifa+" />
			<MenuLinks />
		</Box>
		<MenuIcons />
	</DesktopMenuWrapper>
);

const MobileMenu: React.FC = () => {
	const isMobileMenu = useMediaQuery(`(max-width: ${media.mobile})`);

	return (
		<MobileMenuWrapper>
			<Box
				sx={{
					flex: "1",
				}}>
				<Exist when={isMobileMenu}>
					<HamburgerMenu />
				</Exist>
				<Exist when={!isMobileMenu}>
					<DropdownMenu />
				</Exist>
			</Box>
			<Box
				sx={{
					flex: "1",
					textAlign: "center",
				}}>
				<img src={logo} alt="Fifa+" />
			</Box>
			<Box
				sx={{
					flex: "1",
				}}>
				<MenuIcons />
			</Box>
		</MobileMenuWrapper>
	);
};

export const Header: React.FC = () => {
	const [isScrolledDown, setIsScrolledDown] = useState(false);
	const isSubNavigationVisible = useMediaQuery(`(min-width: ${media.mobile})`);
	const isMobileMenuOpen = useSelector(isMenuOpen);
	const mobileMenuOpenClass = isMobileMenuOpen ? "open" : "";
	const scrolledClass = isScrolledDown ? "header-fill" : "";

	const handleScrollChanges = () => {
		setIsScrolledDown(window.scrollY > 0);
	};

	useEffect(() => {
		const debounceHandleScroll = debounce(handleScrollChanges, 60);
		window.addEventListener("scroll", debounceHandleScroll);
		return () => {
			window.removeEventListener("scroll", debounceHandleScroll);
		};
	}, []);

	return (
		<Wrapper className={`${mobileMenuOpenClass} ${scrolledClass}`}>
			<Container maxWidth={false}>
				<InnerWrapper>
					<DesktopMenu />
					<MobileMenu />
				</InnerWrapper>
			</Container>
			<Exist when={isSubNavigationVisible}>
				<DesktopSubNavigation />
			</Exist>
		</Wrapper>
	);
};
